export default __webpack_public_path__ + "static/media/line-icon.9e397c9f.png";